import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLineInView } from "@/components/Reveal";
import { PHONE_TEL, PHONE_DISPLAY, WHATSAPP_URL } from "@/data/content";

const CtaFinal = () => (
  <section data-testid="cta-final" className="relative bg-carbone text-ivory grain overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-24 md:py-36">
      <Reveal>
        <p className="font-display text-xs tracking-[0.3em] uppercase text-ivory/50 mb-8 flex items-center gap-4">
          <span className="text-terracotta">08</span>
          <span className="h-px w-8 bg-ivory/30" />
          Parliamone
        </p>
      </Reveal>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">
        <MaskedLineInView>Un buon cantiere inizia</MaskedLineInView>
        <MaskedLineInView delay={0.12}>
          <span className="font-serif italic font-normal text-terracotta">da una chiacchierata.</span>
        </MaskedLineInView>
      </h2>
      <Reveal delay={0.25}>
        <p className="mt-8 text-ivory/60 text-base md:text-lg leading-relaxed max-w-xl">
          Raccontaci l'intervento che hai in mente: ti rispondiamo con una
          valutazione concreta e, se serve, fissiamo un sopralluogo.
        </p>
      </Reveal>
      <Reveal delay={0.35}>
        <div className="mt-12 flex flex-col sm:flex-row gap-4">
          <Link
            to="/contatti"
            data-testid="cta-final-sopralluogo"
            className="group inline-flex items-center justify-center gap-3 bg-terracotta hover:bg-terracotta-hover text-ivory font-display text-sm tracking-[0.15em] uppercase px-10 py-5 transition-colors duration-300"
          >
            Raccontaci il tuo progetto
            <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <a
            href={PHONE_TEL}
            data-testid="cta-final-call"
            className="inline-flex items-center justify-center gap-3 border border-ivory/30 hover:border-ivory text-ivory font-display text-sm tracking-[0.15em] uppercase px-10 py-5 transition-colors duration-300"
          >
            Chiama Sopaj — {PHONE_DISPLAY}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-final-whatsapp"
            className="inline-flex items-center justify-center gap-3 text-ivory/60 hover:text-ivory font-display text-sm tracking-[0.15em] uppercase px-4 py-5 transition-colors duration-300 link-underline"
          >
            Scrivici su WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaFinal;
